import { useEffect, useLayoutEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CategoryAction } from "../../redux/Action/ProfileAction";
import { StaffMemberAddAction, StaffMemberCategoryServiceGetAction } from "../../redux/Action/StaffMemberAction";
import $ from "jquery";
import { FormattedMessage } from "react-intl";

const NewStaff = ({ newStaffComponents, register, catgoryError, setService, setCateory, services }: any) => {
    const dispatch = useDispatch<any>();

    const [loading, setLoading] = useState(true);
    const [selectedServicesId, setSelectedServicesId] = useState<any[]>([]);
    const [serviceData, setServiceData] = useState<any[]>([]);

    const category_data = useSelector((state: any) => state.CategoryState);
    const service_data = useSelector((state: any) => state.StaffMemberCategoryServiceState);
    const staff_member_detail: any = useSelector((state: any) => state.StaffMemberDetailState)



    useEffect(() => {
        dispatch(CategoryAction({}));
    }, [dispatch]);

    useEffect(() => {
        if (service_data?.status) {
            const newData = [...serviceData];
            newData[service_data?.data?.custom_params?.index] = service_data?.data?.data;
            setServiceData(newData);
        }else{
            setServiceData([]);
        }
    }, [service_data]);
    

    const handleCategory = (e: any, index: number) => {
        const catId = e.target.value;
        setCateory((prevArr: any) => {
            const existingEntry = prevArr.find((item: any) => item.index === index);
            if (existingEntry) {
                if (existingEntry.catId === catId || catId === "") {
                    return prevArr.filter((item: any) => item.index !== index);
                }
                return prevArr.map((item: any) => item.index === index ? { index, catId } : item);
            }
            else {
                if (catId !== "") {
                    return [...prevArr, { index, catId }];
                }
            }

            return prevArr;
        });
        dispatch(StaffMemberCategoryServiceGetAction({ cat_id: catId, index }));
    };



    const handleSelectServices = (e: any, index: any) => {
        const value = e.target.value;
        const arr = [...selectedServicesId];
        arr[index] = { index, value };
        setSelectedServicesId(arr);
        setService(arr)
    };





    useEffect(() => {
        if (staff_member_detail?.data?.data?.detail?.allCategoryDetails?.length > 0) {
            setTimeout(() => {
                staff_member_detail?.data?.data?.detail?.allCategoryDetails?.map(async (item: any, index: any) => {
                    $(`.cat_select_${index}`).val(item?.id)
                    dispatch(StaffMemberCategoryServiceGetAction({ cat_id: item?.id, index }));
                })
            }, 1000)
        }
    }, [staff_member_detail]);



    useEffect(() => {
        if (services?.length > 0 && serviceData?.length > 0 && category_data?.data?.data?.categories?.length > 0) {
            // setLoading(true);
            // setTimeout(() => {
            services.sort((a: any, b: any) => {
                return parseInt(a.value) - parseInt(b.value)
            })?.map((item: any, index: any) => {
                const arr = [...selectedServicesId];
                arr[index] = { index, value: item?.value };
                setSelectedServicesId(arr);
                $(`.service_select_${index}`).val(Number(item?.value));
            });
            setLoading(false);
            // }, 2000);
        } else {
            setLoading(false);
        }
    }, [services, serviceData]);

    useEffect(() => {

        $(".staff-model-box").click()
        dispatch(StaffMemberAddAction("RESET"))
        dispatch(StaffMemberCategoryServiceGetAction("RESET"))


    }, [])



    return (
        <>

            {
                newStaffComponents?.map((item: any, index: any) => {
                    return (
                        <div className={`${loading ? "col-12 placeholder" : "col-12"} `} key={index}>
                            <div className="row">
                                <div className="col-sm-6">
                                    <div className="normalINput">
                                        <label className="form-label">{<FormattedMessage id="category" />}</label>
                                        <select
                                            className={`form-select cat_select_${index}`}
                                            onChange={(e) => handleCategory(e, index)} >
                                            <option value="">{<FormattedMessage id="select_category" />}</option>
                                            {category_data?.data?.data?.categories?.map(
                                                (catItem: any) => (
                                                    <option
                                                        key={catItem?.category_detail?.id}
                                                        value={catItem?.category_detail?.id}
                                                    >
                                                        {catItem?.category_detail?.name}
                                                    </option>
                                                )
                                            )}
                                        </select>
                                    </div>
                                </div>

                                <div className={`${loading ? "col-sm-6 placeholder" : "col-sm-6"} `}>
                                    <div className="normalINput">
                                        <label className="form-label">{<FormattedMessage id="service" />}</label>
                                        <select
                                            className={`form-select service_select_${index}`}
                                            {...register(`service${index}`)}
                                            onChange={(e) => handleSelectServices(e, index)}
                                        >
                                            <option value="">{<FormattedMessage id="select_service" />}</option>
                                            {serviceData[index]?.length > 0 &&
                                                serviceData[index]?.map(
                                                    (serviceItem: any) => (
                                                        <option
                                                            key={serviceItem?.id}
                                                            value={serviceItem?.id}
                                                            selected={Number(selectedServicesId[index]?.value) === Number(serviceItem?.id)}
                                                        >
                                                            {serviceItem?.name}
                                                        </option>
                                                    )
                                                )}
                                        </select>

                                    </div>

                                </div>
                            </div>
                        </div>
                    )
                }

                )}
            {catgoryError ? <span className="text-danger" > {catgoryError}</span> : ""}
        </>
    );
};

export default NewStaff;

